import { stringify as stringifyQs } from 'query-string';
import getConfig from '~/config';
import downloadFile from "~/lib/downloadFile";

export function fieldFile(model, id, fieldName) {
    const baseUrl = getConfig().basePublicUrl;
    let pathStr = `${baseUrl}/admin/${model}/${id}/${fieldName}/file`;
    return pathStr;
}


export function timthumb(pathStr, resizeProps) {
    const baseUrl = getConfig().basePublicUrl;

    let queryStr = stringifyQs(resizeProps);
        queryStr = queryStr.length ? `&${queryStr}` : '';
        pathStr = encodeURIComponent(`${pathStr}`);

    return `${baseUrl}/tt/timthumb.php?src=${pathStr}${queryStr}`;
}

export function getDownloadUrl(id) {
    const baseUrl = getConfig().baseUrl;
    return `${baseUrl}/file_download/${id}`;
}

export const downloadWebsailFile = (id) => {
    let downloadUrl = getDownloadUrl(id);
    downloadFile(downloadUrl);
};